

<agm-map [latitude]="lat" [longitude]="lng" style="height: 500px">
    <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
  </agm-map>
